import { useQsFilters } from "@dash/filters";
import { useEffect, useRef } from "react";

import { CustomerAnalyticsViewFilters, customerAnalyticsViewFiltersSerializer } from "@megaron/megarax-uri";

import { AnalyticsPreset } from "./analyticsPreset";

export type Filters = CustomerAnalyticsViewFilters;

export const useCustomerAnalyticsGlobalFilters = (
  preset: AnalyticsPreset,
  updatePreset: (newPreset: AnalyticsPreset) => void,
) => {
  const isPresetUpdatedOnMount = useRef(false);

  const defaultFilters: Filters = {
    aggName: undefined,
    sort: preset.sortBy,
    isMyRegion: preset.filters.find((f) => f.isMyRegion !== undefined)?.isMyRegion,
    region: preset.filters.find((f) => f.region)?.region,
    status: preset.filters.find((f) => f.status)?.status,
    category: preset.filters.find((f) => f.category)?.category,
    customerId: preset.filters.find((f) => f.customerId)?.customerId,
    timeStart: preset.filters.find((f) => f.timeStart)?.timeStart,
    timeEnd: preset.filters.find((f) => f.timeEnd)?.timeEnd,
    timeUnit: preset.filters.find((f) => f.timeUnit)?.timeUnit,
    unitCount: preset.filters.find((f) => f.unitCount)?.unitCount,
    selectedTimeName: preset.filters.find((f) => f.selectedTimeName)?.selectedTimeName,
    productGroups: preset.filters.find((f) => f.productGroups)?.productGroups,
  };

  const { filters, setFilters, setFilter } = useQsFilters(customerAnalyticsViewFiltersSerializer, defaultFilters);

  useEffect(() => {
    if (!isPresetUpdatedOnMount.current) {
      updatePreset({ ...preset, filters: [filters] });
      isPresetUpdatedOnMount.current = true;
    }
  }, [filters, isPresetUpdatedOnMount, preset, updatePreset]);

  return { filters, setFilter, setFilters, isPresetUpdatedOnMount: isPresetUpdatedOnMount.current };
};
